module.exports = __webpack_public_path__ + "static/media/cursor.7765f17d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/cursor.svg
// module id = 1057
// module chunks = 0